import LawyerFA from './fa/fa.json'

const LawyerMessages = {
  fa: { ...LawyerFA },
}

export default LawyerMessages
